import styled from '@emotion/styled';

import LoadingSpinner from '../LoadingSpinner';
import COLOR from '../../../../shared/constant/colorset';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 370px;
  margin-bottom: 16px;
  background-color: ${COLOR.kurlyGray200};
`;

export default function MainBannerLoading() {
  return (
    <Container>
      <LoadingSpinner/>
    </Container>
  );
}
